import { createModuleWithSlices } from "@comact/crc";
import * as requests from "./requests";
import * as selectors from "./selectors";
import slices, { actions } from "./slices";

export * from "./model";

export const UserModule = createModuleWithSlices({ slices, actions, requests, selectors });
